export default __webpack_public_path__ + "static/中科软-王明耀-a780348fe4c82f3b1a1c3076fd6ddbe5.png";